// src/http.js
import axios from "axios";

// Istanza condivisa per TUTTO il frontend
export const http = axios.create({
  baseURL: "/",                 // stesso dominio
  withCredentials: true,        // invia cookie PHPSESSID sempre
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

// Listener esterno per logout forzato (es. 401)
let onUnauthorized = null;

export function setUnauthorizedHandler(fn) {
  onUnauthorized = fn;
}

// Interceptor: se il backend risponde 401 → trigger logout globale
http.interceptors.response.use(
  (res) => res,
  (err) => {

    // 🔥 DEBUG (puoi lasciarlo per ora)
    console.log("HTTP ERROR", {
      url: err?.config?.url,
      status: err?.response?.status,
      data: err?.response?.data,
    });

    if (err?.response?.status === 401 && typeof onUnauthorized === "function") {
      onUnauthorized();
    }

    return Promise.reject(err);
  }
);